/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import React, { useEffect, useContext } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { SiWhatsapp } from "react-icons/si";

const Layout = ({ children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <a href="http://wa.me/+447916743112" target="_blank">
        <div className="fixed flex justify-center items-center cursor-pointer bottom-8 left-8 w-[70px] h-[70px] rounded-full bg-green-500 hover:bg-green-800 z-20">
          <SiWhatsapp className="text-white text-4xl" />
        </div>
      </a>
      <main className="">{children}</main>
      <Footer />
    </>
  );
};

export default Layout;